class MaterialsGuide {
  constructor() {
    this.guides = document.querySelectorAll('[data-materials-guide]');
    this.init();
  }

  init() {
    this.guides.forEach(guide => {
      const tabs = guide.querySelectorAll('[data-materials-tab]');
      const panes = guide.querySelectorAll('.agnoulita-materials-pane');

      tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const tabId = tab.getAttribute('data-materials-tab');
          this.setActiveTab(guide, tabId, tabs, panes);
        });
      });

      // Set initial active tab
      this.setActiveTab(guide, 'felt', tabs, panes);
    });
  }

  setActiveTab(guide, tabId, tabs, panes) {
    // Remove active class from all tabs and panes
    tabs.forEach(tab => tab.classList.remove('active'));
    panes.forEach(pane => pane.classList.remove('active'));

    // Add active class to selected tab and pane
    const selectedTab = guide.querySelector(`[data-materials-tab="${tabId}"]`);
    const selectedPane = guide.querySelector(`#${tabId}`);

    if (selectedTab && selectedPane) {
      selectedTab.classList.add('active');
      selectedPane.classList.add('active');

      if (window.innerWidth < 768) {
        selectedTab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MaterialsGuide());
} else {
  new MaterialsGuide();
}